import { render, staticRenderFns } from "./BaselineComparison.vue?vue&type=template&id=4964cf9d"
import script from "./BaselineComparison.vue?vue&type=script&lang=js"
export * from "./BaselineComparison.vue?vue&type=script&lang=js"
import style0 from "./BaselineComparison.vue?vue&type=style&index=0&id=4964cf9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports